<template>
    <div class="check-report">
        <div
            v-if="results.length === 0"
            class="check-report__verdict check-report__verdict--safe"
        >
            ✓ {{ safeMessage }}
        </div>
        <template v-else>
            <div class="check-report__verdict check-report__verdict--unsafe">
                ✗ {{ unsafeMessage }}
            </div>
            <ul class="check-report__list">
                <li
                    v-for="(result, index) in results"
                    :key="index"
                    class="check-report__item"
                >
                    {{ result }}
                </li>
            </ul>
            <p
                v-if="footer"
                class="check-report__footer"
            >
                {{ footer }}
            </p>
        </template>
    </div>
</template>

<script setup>

defineProps({
    results: {
        type: Array,
        default: () => []
    },
    safeMessage: {
        type: String,
        required: true
    },
    unsafeMessage: {
        type: String,
        required: true
    },
    footer: {
        type: String,
        default: null
    }
})
</script>

<style lang="scss" scoped>
.check-report {
    border: 1px solid var(--colorAppBorder);
    border-radius: 4px;
    padding: 0.75rem 1rem;
    background: var(--cui-body-bg);
}

.check-report__verdict {
    font-weight: 600;
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
}

.check-report__verdict--safe {
    color: #2eb85c;
}

.check-report__verdict--unsafe {
    color: #e55353;
}

.check-report__list {
    margin: 0;
    padding-left: 1.25rem;
    font-size: 0.875rem;
    color: var(--cui-body-color);
}

.check-report__item {
    padding: 0.125rem 0;
    opacity: 0.75;
}

.check-report__footer {
    margin-top: 0.5rem;
    margin-bottom: 0;
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--cui-body-color);
}
</style>
